export enum IntegratedCareReturnDeliveryChannel {
  CREATE = 'integratedCareReturnDelivery::create',
  EDIT = 'integratedCareReturnDelivery::patch',
  DELETE = 'integratedCareReturnDelivery::delete',
}
